<div *transloco="let t" class="flex max-h-[90vh] flex-col overflow-hidden">
  <header class="mt-5 flex shrink-0 items-center gap-3 pl-6">
    <div
      class="flex size-12 items-center justify-center rounded-3xl bg-blue-light p-3 text-blue"
    >
      <mat-icon
        class="material-icons-outlined items-center justify-center text-xl"
        style="display: inline-flex"
      >
        person_add
      </mat-icon>
    </div>
    <p class="text-lg font-semibold">
      {{ t('portal.courses.enrollment.addParticipantsHeadline') }}
    </p>
  </header>

  <div class="min-h-80 w-full flex-1 overflow-y-auto px-6 py-2">
    @if (filteredStudents) {
      <app-learning-plan-enrollment-table
        [students]="filteredStudents"
        [selectedStudents]="selectedStudents"
        [searchTerm]="searchTerm"
        (primaryButtonClickEvent)="handleUserCreationButtonClick()"
        (searchTermChanged)="onSearchTermChanged($event)"
      ></app-learning-plan-enrollment-table>
      <div class="mt-4 flex flex-col">
        <span class="text-lg font-semibold">{{
          t('portal.courses.enrollment.reminder.title')
        }}</span>
        <span class="mt-2 text-sm font-medium">{{
          t('portal.courses.enrollment.reminder.description')
        }}</span>
      </div>
      <div class="mb-2 mt-3">
        <app-license-info-card
          animate.enter="ease-in-animation"
          [type]="selectedStudents.length ? 'enrollment' : 'basic'"
          [enrollmentDescription]="getEnrollmentDescription()"
          (addLicensesButtonClickEvent)="addLicensesButtonClickEvent.emit()"
          [showLicenseRatioCard]="canEnroll"
          [pendingLicenseAssignments]="pendingLicenseAssignments"
        ></app-license-info-card>
      </div>
    } @else {
      <div
        class="absolute left-1/2 top-1/2 size-8 -translate-x-1/2 -translate-y-1/2"
      >
        <app-loading />
      </div>
    }
  </div>

  <footer class="w-full shrink-0 border-t-2 border-grey-lightGrey px-4 py-1">
    <app-button-row
      [primaryButtonText]="t('portal.courses.enrollment.enrollButtonText')"
      (primaryButtonClickedEvent)="enrollStudents()"
      [disablePrimaryButton]="selectedStudents.length === 0 || !canEnroll"
      [isLoading]="isLoading"
      [secondaryButtonText]="t('general.abort')"
      (secondaryButtonClickedEvent)="handleAbortButtonClick()"
    ></app-button-row>
  </footer>
</div>
